import { useRef, useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { BYTES_PER_MB, MAX_UPLOAD_MB } from "@/lib/constants";
import { prepareImage } from "@/lib/imagePrep";

const looksLikeImage = (file) => file.type.startsWith("image/") || /\.(heic|heif|jpe?g|png|webp|gif)$/i.test(file.name || "");

export const useImageUpload = ({ isPublic = false, onUploaded }) => {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef();

  const onFile = async (e) => {
    const raw = e.target.files?.[0];
    if (!raw) return;
    if (!looksLikeImage(raw)) return toast.error("Please upload an image file");
    setUploading(true);
    try {
      const file = await prepareImage(raw);
      if (file.size > MAX_UPLOAD_MB * BYTES_PER_MB) return toast.error(`Image must be under ${MAX_UPLOAD_MB}MB`);
      const fd = new FormData();
      fd.append("file", file);
      if (isPublic) fd.append("public", "true");
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded(data, file);
    } catch (err) {
      toast.error(apiError(err, "Upload failed. Please try another photo."));
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const reset = () => { if (inputRef.current) inputRef.current.value = ""; };
  const pick = () => inputRef.current?.click();

  return { uploading, inputRef, onFile, reset, pick };
};
